import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../../../../assets/images/chat/audio-call.svg'
import _imports_1 from '../../../../../assets/images/chat/video-call.svg'
import _imports_2 from '../../../../../assets/images/chat/outgoing-call.svg'


const _hoisted_1 = {
  key: 0,
  class: "threads-container-wrapper d-flex flex-column h-100"
}
const _hoisted_2 = { class: "conversation-header py-2" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify-content-between w-100 header-top px-3 pb-1"
}
const _hoisted_4 = { class: "group-name-text" }
const _hoisted_5 = { class: "px-3" }
const _hoisted_6 = {
  key: 0,
  class: "d-flex mt-1"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading w-10 me-4 lighten mt-1" }, null, -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading w-10 lighten mt-1" }, null, -1 /* HOISTED */)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "d-flex mt-1"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Family Group", -1 /* HOISTED */)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "fp-conversation-body ps-4 w-100" }
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"message-header\"><div class=\"sender-info\"><div class=\"ava-initials\"><span></span></div><div class=\"message-text\"><span class=\"shimmer-loading w-40 lighten\"></span><span class=\"shimmer-loading w-25 lighten mt-1\"></span></div></div><span class=\"shimmer-loading w-15 lighten\"></span></div>", 1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "message-subject mt-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading w-70 lighten" })
], -1 /* HOISTED */)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "message-body mt-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading w-90 lighten" }),
  /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading w-80 lighten mt-1" })
], -1 /* HOISTED */)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading w-30 lighten" })
], -1 /* HOISTED */)
const _hoisted_18 = { class: "w-100" }
const _hoisted_19 = { class: "d-flex justify-content-between align-items-center min-width-0 h-100" }
const _hoisted_20 = { class: "d-flex align-items-center" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "ps-2 flex-grow-1 min-width-0" }
const _hoisted_23 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_24 = { class: "mb-1 fw-bold text-dark" }
const _hoisted_25 = { class: "d-flex align-items-center" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1 /* HOISTED */)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1 /* HOISTED */)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = {
  key: 0,
  class: "call-history-panel table-container"
}
const _hoisted_33 = { class: "call-history-table" }
const _hoisted_34 = { class: "famcall-history-table" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "table-header" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Date and Time"),
    /*#__PURE__*/_createElementVNode("th", null, "Call Duration"),
    /*#__PURE__*/_createElementVNode("th", null, "Status")
  ])
], -1 /* HOISTED */)
const _hoisted_36 = { key: 0 }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "3",
  class: "no-data"
}, [
  /*#__PURE__*/_createElementVNode("h3", null, "No Call History Found.")
], -1 /* HOISTED */)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "status-outgoing" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "sort-type-icon",
      src: _imports_2
    }),
    /*#__PURE__*/_createTextVNode(" Outgoing ")
  ])
], -1 /* HOISTED */)
const _hoisted_40 = { class: "d-flex w-100 align-items-baseline subject-input-div" }
const _hoisted_41 = { class: "form-group w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FPThreadsCard = _resolveComponent("FPThreadsCard")!
  const _component_MessageInputHandler = _resolveComponent("MessageInputHandler")!
  const _directive_alphanumeric_special_only = _resolveDirective("alphanumeric-special-only")!
  const _directive_focus = _resolveDirective("focus")!

  return (_ctx.isLoading || _ctx.isLoadingThreads || _ctx.hasThreads)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          (_ctx.selectedConversation?.conversationGroupType)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.GroupType.getKeyUsingValue(_ctx.selectedConversation.conversationGroupType)) + " Group", 1 /* TEXT */),
                (!_ctx.isLoading && !_ctx.isLoadingThreads && _ctx.canEditPatient)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-primary compose-btn",
                      type: "button",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleCompose && _ctx.handleCompose(...args)))
                    }, " Compose "))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.isLoading || _ctx.isLoadingThreads)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_6, _hoisted_9))
              : (_ctx.conversationThreadsInfo)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                    _createElementVNode("li", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleActiveTab(_ctx.FPTabsEnum.Thread))),
                      class: _normalizeClass(["cursor-pointer me-4 fw-bold", { 'border-bottom border-primary': _ctx.activeTab == _ctx.FPTabsEnum.Thread }]),
                      style: {"border-width":"3px !important"}
                    }, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["link-btn nav-link menu-link", `${_ctx.activeTab == _ctx.FPTabsEnum.Thread ? 'text-primary' : 'text-secondary'}`])
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.formatDisplayUsers([_ctx.conversationThreadsInfo?.patientDetail])), 1 /* TEXT */)
                      ], 2 /* CLASS */)
                    ], 2 /* CLASS */),
                    _createElementVNode("li", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleActiveTab(_ctx.FPTabsEnum.FamilyGroup))),
                      class: _normalizeClass(["cursor-pointer fw-bold", { 'border-bottom border-primary': _ctx.activeTab == _ctx.FPTabsEnum.FamilyGroup }]),
                      style: {"border-width":"3px !important"}
                    }, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["link-btn nav-link menu-link", `${_ctx.activeTab == _ctx.FPTabsEnum.FamilyGroup ? 'text-primary' : 'text-secondary'}`])
                      }, _hoisted_12, 2 /* CLASS */)
                    ], 2 /* CLASS */)
                  ]))
                : _createCommentVNode("v-if", true)
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", {
            class: _normalizeClass(["h-100 pe-4 fp-conversation-main", { 'custom-scrollbar': _ctx.userOs == 'Windows' }]),
            ref: "fpConversationMain"
          }, [
            (_ctx.isLoading || _ctx.isLoadingThreads)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(2, (i) => {
                  return _createElementVNode("div", {
                    key: i,
                    class: "thread-card shimmer-thread"
                  }, [
                    _createCommentVNode(" Header "),
                    _hoisted_14,
                    _createCommentVNode(" Subject "),
                    _hoisted_15,
                    _createCommentVNode(" Body "),
                    _hoisted_16,
                    _createCommentVNode(" Reply placeholder spacing "),
                    _hoisted_17
                  ])
                }), 64 /* STABLE_FRAGMENT */))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.conversationThreadsInfo?.threads, (thread) => {
                  return (_openBlock(), _createBlock(_component_FPThreadsCard, {
                    key: thread.id,
                    thread: thread,
                    patientAgencyName: _ctx.conversationThreadsInfo?.patientDetail?.agencyName,
                    canEditPatient: _ctx.canEditPatient
                  }, null, 8 /* PROPS */, ["thread", "patientAgencyName", "canEditPatient"]))
                }), 128 /* KEYED_FRAGMENT */))
          ], 2 /* CLASS */)
        ], 512 /* NEED_PATCH */), [
          [_vShow, _ctx.activeTab == _ctx.FPTabsEnum.Thread]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_18, [
          _createElementVNode("ul", {
            class: _normalizeClass(["nav list-group list-group-flush message-navigation", { 'custom-scrollbar': _ctx.userOs == 'Windows' }])
          }, [
            (_ctx.familyContacts && _ctx.familyContacts.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.familyContacts, (contact, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: contact?.id,
                    class: "nav-item list-group-item message-list-item call-list call-list-height"
                  }, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("span", {
                          class: "expand-arrow",
                          onClick: _withModifiers(($event: any) => (_ctx.toggleDropdown(contact.calls, index)), ["stop"])
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(_ctx.expandedIndex === index ? 'fas fa-angle-up' : 'fas fa-angle-down')
                          }, null, 2 /* CLASS */)
                        ], 8 /* PROPS */, _hoisted_21),
                        _createElementVNode("div", {
                          class: _normalizeClass(["ava-initials flex-shrink-0 me-1", `ava-initials-${_ctx.getSolutionClassIndex(index)}`])
                        }, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.formatUserInitials({
                                            firstName: contact?.firstName,
                                            lastName: contact?.lastName
                                        })), 1 /* TEXT */)
                        ], 2 /* CLASS */),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("span", _hoisted_24, [
                              _createElementVNode("span", null, _toDisplayString(contact?.firstName) + " " + _toDisplayString(contact?.lastName), 1 /* TEXT */)
                            ])
                          ]),
                          _createElementVNode("span", null, _toDisplayString(contact?.relationship), 1 /* TEXT */)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        (!_ctx.isCallOngoing)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass(["ms-1", [_ctx.dialogOpened ? 'cursor-not-allowed' : 'cursor-pointer']]),
                              onClick: ($event: any) => (!_ctx.dialogOpened && _ctx.startMeeting(_ctx.ConversationRoomTypeEnum.AudioCall, contact)),
                              title: "Audio Call"
                            }, _hoisted_28, 10 /* CLASS, PROPS */, _hoisted_26))
                          : _createCommentVNode("v-if", true),
                        (!_ctx.isCallOngoing)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: _normalizeClass(["mx-2 mx-lg-4", [_ctx.dialogOpened ? 'cursor-not-allowed' : 'cursor-pointer']]),
                              onClick: ($event: any) => (!_ctx.dialogOpened && _ctx.startMeeting(_ctx.ConversationRoomTypeEnum.VideoCall, contact)),
                              title: "Video Call"
                            }, _hoisted_31, 10 /* CLASS, PROPS */, _hoisted_29))
                          : _createCommentVNode("v-if", true)
                      ])
                    ]),
                    (_ctx.expandedIndex === index)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("table", _hoisted_34, [
                              _hoisted_35,
                              _createElementVNode("tbody", null, [
                                (!_ctx.selectedCallHistory.length)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_36, _hoisted_38))
                                  : _createCommentVNode("v-if", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedCallHistory, (call) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: call.id
                                  }, [
                                    _createElementVNode("td", null, _toDisplayString(_ctx.formatDateTimeToLocal(call.startTime)), 1 /* TEXT */),
                                    _createElementVNode("td", null, _toDisplayString(call.callDuration || "-"), 1 /* TEXT */),
                                    _hoisted_39
                                  ]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */)
        ], 512 /* NEED_PATCH */), [
          [_vShow, _ctx.activeTab == _ctx.FPTabsEnum.FamilyGroup]
        ]),
        (_ctx.openCompose)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control border-0",
                    placeholder: "Enter Thread Subject (Required)",
                    maxlength: "250",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.subject) = $event))
                  }, null, 512 /* NEED_PATCH */), [
                    [_directive_alphanumeric_special_only],
                    [_vModelText, _ctx.subject],
                    [_directive_focus, _ctx.focusOnInput]
                  ])
                ])
              ]),
              _createVNode(_component_MessageInputHandler, {
                send: _ctx.sendMessage,
                "should-disable-send": _ctx.subject?.length < 1,
                "refs-name": `threadEditorRef-${_ctx.selectedConversationId}`,
                "toggle-important": _ctx.toggleImportant,
                isFamilyPortal: true
              }, null, 8 /* PROPS */, ["send", "should-disable-send", "refs-name", "toggle-important"])
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}